<div class="pr-3  pl-4 h-full w-full flex flex-col" (window:resize)="onResize()"> 
  <div class="title-page"><span class="title">&nbsp;</span>
     
  </div>
  <form nz-form class="ant-advanced-search-form" #pageSearch>
    <div nz-row [nzGutter]="24">

      <div nz-col nzSm="24" nzMd="12" nzLg="6" nzXl="6">
        <nz-form-item>
          <nz-form-label nzSpan="24" nzRequired>Tỉnh thành</nz-form-label>
          <asc-autocomplete [ascModel]="provinceControl" (ascModelChange)="changeProvince($event)"
            [placeholder]="'Chọn tỉnh thành'" [getListAC]="getProvinceACFn"></asc-autocomplete>
        </nz-form-item>
      </div>
  
      <div nz-col nzSm="24" nzMd="12" nzLg="6" nzXl="6">
        <nz-form-item>
          <nz-form-label nzSpan="24" nzRequired>Quận huyện</nz-form-label>
          <asc-autocomplete [ascModel]="districtControl" (ascModelChange)="changeDistrict($event)"
            [placeholder]="'Chọn quận huyện'" [getListAC]="getDistrictACFn"></asc-autocomplete>
        </nz-form-item>
      </div>

      <div nz-col nzSm="24" nzMd="12" nzLg="6" nzXl="6">
        <nz-form-item>
          <nz-form-label nzSpan="24" nzRequired>Tên Loại hình cơ sở giáo dục</nz-form-label>
          <asc-autocomplete [ascModel]="typeofschoolControl" (ascModelChange)="changeTypeOfSchool($event)"
            [placeholder]="'Chọn Loại hình cơ sở giáo dục'" [getListAC]="getTypeOfSchoolACFn"></asc-autocomplete>
        </nz-form-item>
      </div>

      <div nz-col nzSm="24" nzMd="12" nzLg="6" nzXl="6">
        <nz-form-item>
          <nz-form-label nzSpan="24" nzRequired>Tên cấp học</nz-form-label>
          <asc-autocomplete [ascModel]="schoollevelControl" (ascModelChange)="changeSchoolLevel($event)"
            [placeholder]="'Chọn cấp học'" [getListAC]="getSchoolLevelACFn"></asc-autocomplete>
        </nz-form-item>
      </div>

    <div nz-col nzSm="24" nzMd="12" nzLg="6" nzXl="6">
      <nz-form-item>
        <nz-form-label nzSpan="24" nzFor="ma">Mã</nz-form-label>
        <nz-form-control nzSpan="24">
          <input nz-input [(ngModel)]="commonFilter.EducationAndTrainingCode" [ngModelOptions]="{standalone: true}" />
        </nz-form-control>
      </nz-form-item>
    </div>
    <div nz-col nzSm="24" nzMd="12" nzLg="6" nzXl="6">
      <nz-form-item>
        <nz-form-label nzSpan="24" nzFor="ma">Tên cơ sở</nz-form-label>
        <nz-form-control nzSpan="24">
          <input nz-input [(ngModel)]="commonFilter.EducationAndTrainingName" [ngModelOptions]="{standalone: true}" />
        </nz-form-control>
      </nz-form-item>
    </div>
 
    </div>
    <div nz-row>
      <div nz-col [nzSpan]="24" class="search-area">
        <ng-container *ngIf="btnType === buttonTypeEnum.TEXT">
          <button nz-button class="flex items-center justify-center" [nzType]="'primary'" (click)="search()">Tìm
            kiếm</button>
        </ng-container>
        <!-- <ng-container *ngIf="btnType === buttonTypeEnum.ICON"> -->
          <button nz-button class="flex items-center justify-center" style="width: 100px;" [nzType]="'primary'"
            nzTooltipTitle="Tìm kiếm" nzTooltipPlacement="bottom" nz-tooltip (click)="search()"><i nz-icon
              nzType="search" nzTheme="outline"></i></button>
        <!-- </ng-container> -->
        <ng-container *ngIf="btnType === buttonTypeEnum.TEXTANDICON">
           
          <button nz-button class="flex items-center justify-center" [nzType]="'primary'"><i nz-icon nzType="search"
              nzTheme="outline"></i>Tìm kiếm</button>
        </ng-container>
      </div>
    </div>
  </form>
  <div class="relative">
    <nz-table [nzShowTotal]="rangeTemplate" #Table nzOuterBordered nzShowSizeChanger [nzData]="schoolList" nzSize="small"
      [nzScroll]="{x: width +'px', y: height + 'px'}" class="absolute w-full" [nzFrontPagination]="false"
      [nzTotal]="Total" [nzPageSize]="pageSize" [nzPageIndex]="pageIndex" [nzPageSizeOptions]="pageSizeOptions"
      (nzPageIndexChange)="pageIndexEvent($event)" (nzPageSizeChange)="pageSizeEvent($event)" (nzCurrentPageDataChange)="onCurrentPageDataChange($event)">
      <thead>
        <tr #pageHeaderTable>
          <th nzLeft nzWidth="50px" [(nzChecked)]="checked" [nzIndeterminate]="indeterminate"
          (nzCheckedChange)="onAllChecked($event)"></th>
          <th nzWidth="50px" nzLeft >STT</th>

          <th nzWidth="100px" nzLeft>Mã đơn vị</th>
          <th >Tên cơ sở</th>
          <th >Loại hình cơ sở giáo dục</th>
          <th >Cấp học</th>
          <th >Tỉnh thành</th>
          <th >Quận huyện</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of Table.data; let i = index">
          <td nzLeft [nzChecked]="setOfCheckedId.has(item.id)" (nzCheckedChange)="onItemChecked(item.id, $event)"></td>
          <td nzLeft>{{ i + 1 + (pageIndex-1)*pageSize }}</td>
          <td nzLeft>{{item.educationAndTrainingCode}}</td>
          <td>{{item.educationAndTrainingName}}</td>
          <td>{{item.typeOfSchoolName}}</td>
          <td>{{item.schoollevelName}}</td>
          <td>{{item.provinceName}} </td>
          <td>{{item.districtName}}</td>
        </tr>
      </tbody>
    </nz-table>
  </div>
</div>
<ng-keyboard-shortcuts [shortcuts]="shortcuts"></ng-keyboard-shortcuts>
<div *nzModalFooter>
  <button nz-button (click)="close()" [disabled] = "isDisabled">Đóng</button>
  <button nz-button nzType="danger"  (click)="deleteSchool()">Xóa</button>
</div>
<ng-template #rangeTemplate let-range="range" let-total> {{ range[0] }}-{{ range[1] }} của {{ Total }} </ng-template>